import { Select } from "antd";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import Service from "../../service/mgt-permission";
import Actions from "../../redux/actions";
import LoadingContent from "../../component/loading/LoadingContent";
import actions from "../../redux/actions";
import MgtPermission from "./MgtPermission";

const { Option } = Select;

const Section = styled.section`
  height: 100%;
  & > .container {
    height: 100%;
  }
`;

const GroupSelector = styled(Select)`
  width: 200px;
  & > * {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export default function Index(props) {
  const data = useSelector((state) => state.mgtPermission.data);
  const [selectedGroupId, setSelectedGroupId] = useState();
  const [content, setContent] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.master.setPath("/mgt-permission"));
    const init = async () => {
      let result = await Service.search();
      if (result) {
        dispatch(Actions.MgtPermission.setData(result));
        setSelectedGroupId(result.length > 0 ? result[0].id : null);
        setContent(true);
      }
    };

    init();
  }, [dispatch]);

  return (
    <Section
      className={
        "section-mgt-user-permission" + (props.className ? props.className : "")
      }
    >
      <div className="container">
        {!content ? (
          <LoadingContent />
        ) : (
          <>
            <div className="page-title">
              <img src="/image/permission.png" alt="icon-permission" />
              <span>จัดการสิทธิ์การใช้งานข้อมูล</span>
            </div>
            <div className="form-container">
              <GroupSelector
                className="sel-user-role"
                defaultValue={data.length > 0 ? data[0].id : null}
                onChange={(e) => {
                  setSelectedGroupId(e);
                }}
              >
                {data.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.disp_name}
                  </Option>
                ))}
              </GroupSelector>
              <MgtPermission
                groupId={selectedGroupId}
                data={
                  data.find((item) => item.id == selectedGroupId).permissions
                }
              />
            </div>
          </>
        )}
      </div>
    </Section>
  );
}
